module.exports = __webpack_public_path__ + "static/media/heart2.ed66e9d0.png";